import green_light_01 from '../../studio/assets/illustrations/green_light_01.png';
import green_medium_01 from '../../studio/assets/illustrations/green_medium_01.png';
import green_dark_01 from '../../studio/assets/illustrations/green_dark_01.png';
import orange_light_01 from '../../studio/assets/illustrations/orange_light_01.png';
import orange_medium_01 from '../../studio/assets/illustrations/orange_medium_01.png';
import orange_dark_01 from '../../studio/assets/illustrations/orange_dark_01.png';
import blue_light_01 from '../../studio/assets/illustrations/blue_light_01.png';
import blue_medium_01 from '../../studio/assets/illustrations/blue_medium_01.png';
import blue_dark_01 from '../../studio/assets/illustrations/blue_dark_01.png';
import yellow_light_01 from '../../studio/assets/illustrations/yellow_light_01.png';
import yellow_medium_01 from '../../studio/assets/illustrations/yellow_medium_01.png';
import yellow_dark_01 from '../../studio/assets/illustrations/yellow_dark_01.png';
import navy_light_01 from '../../studio/assets/illustrations/navy_light_01.png';
import navy_medium_01 from '../../studio/assets/illustrations/navy_medium_01.png';
import navy_dark_01 from '../../studio/assets/illustrations/navy_dark_01.png';

import green_light_02 from '../../studio/assets/illustrations/green_light_02.png';
import green_medium_02 from '../../studio/assets/illustrations/green_medium_02.png';
import green_dark_02 from '../../studio/assets/illustrations/green_dark_02.png';
import orange_light_02 from '../../studio/assets/illustrations/orange_light_02.png';
import orange_medium_02 from '../../studio/assets/illustrations/orange_medium_02.png';
import orange_dark_02 from '../../studio/assets/illustrations/orange_dark_02.png';
import blue_light_02 from '../../studio/assets/illustrations/blue_light_02.png';
import blue_medium_02 from '../../studio/assets/illustrations/blue_medium_02.png';
import blue_dark_02 from '../../studio/assets/illustrations/blue_dark_02.png';
import yellow_light_02 from '../../studio/assets/illustrations/yellow_light_02.png';
import yellow_medium_02 from '../../studio/assets/illustrations/yellow_medium_02.png';
import yellow_dark_02 from '../../studio/assets/illustrations/yellow_dark_02.png';
import navy_light_02 from '../../studio/assets/illustrations/navy_light_02.png';
import navy_medium_02 from '../../studio/assets/illustrations/navy_medium_02.png';
import navy_dark_02 from '../../studio/assets/illustrations/navy_dark_02.png';

import green_light_03 from '../../studio/assets/illustrations/green_light_03.png';
import green_medium_03 from '../../studio/assets/illustrations/green_medium_03.png';
import green_dark_03 from '../../studio/assets/illustrations/green_dark_03.png';
import orange_light_03 from '../../studio/assets/illustrations/orange_light_03.png';
import orange_medium_03 from '../../studio/assets/illustrations/orange_medium_03.png';
import orange_dark_03 from '../../studio/assets/illustrations/orange_dark_03.png';
import blue_light_03 from '../../studio/assets/illustrations/blue_light_03.png';
import blue_medium_03 from '../../studio/assets/illustrations/blue_medium_03.png';
import blue_dark_03 from '../../studio/assets/illustrations/blue_dark_03.png';
import yellow_light_03 from '../../studio/assets/illustrations/yellow_light_03.png';
import yellow_medium_03 from '../../studio/assets/illustrations/yellow_medium_03.png';
import yellow_dark_03 from '../../studio/assets/illustrations/yellow_dark_03.png';
import navy_light_03 from '../../studio/assets/illustrations/navy_light_03.png';
import navy_medium_03 from '../../studio/assets/illustrations/navy_medium_03.png';
import navy_dark_03 from '../../studio/assets/illustrations/navy_dark_03.png';

import green_light_04 from '../../studio/assets/illustrations/green_light_04.png';
import green_medium_04 from '../../studio/assets/illustrations/green_medium_04.png';
import green_dark_04 from '../../studio/assets/illustrations/green_dark_04.png';
import orange_light_04 from '../../studio/assets/illustrations/orange_light_04.png';
import orange_medium_04 from '../../studio/assets/illustrations/orange_medium_04.png';
import orange_dark_04 from '../../studio/assets/illustrations/orange_dark_04.png';
import blue_light_04 from '../../studio/assets/illustrations/blue_light_04.png';
import blue_medium_04 from '../../studio/assets/illustrations/blue_medium_04.png';
import blue_dark_04 from '../../studio/assets/illustrations/blue_dark_04.png';
import yellow_light_04 from '../../studio/assets/illustrations/yellow_light_04.png';
import yellow_medium_04 from '../../studio/assets/illustrations/yellow_medium_04.png';
import yellow_dark_04 from '../../studio/assets/illustrations/yellow_dark_04.png';
import navy_light_04 from '../../studio/assets/illustrations/navy_light_04.png';
import navy_medium_04 from '../../studio/assets/illustrations/navy_medium_04.png';
import navy_dark_04 from '../../studio/assets/illustrations/navy_dark_04.png';

import green_light_05 from '../../studio/assets/illustrations/green_light_05.png';
import green_medium_05 from '../../studio/assets/illustrations/green_medium_05.png';
import green_dark_05 from '../../studio/assets/illustrations/green_dark_05.png';
import orange_light_05 from '../../studio/assets/illustrations/orange_light_05.png';
import orange_medium_05 from '../../studio/assets/illustrations/orange_medium_05.png';
import orange_dark_05 from '../../studio/assets/illustrations/orange_dark_05.png';
import blue_light_05 from '../../studio/assets/illustrations/blue_light_05.png';
import blue_medium_05 from '../../studio/assets/illustrations/blue_medium_05.png';
import blue_dark_05 from '../../studio/assets/illustrations/blue_dark_05.png';
import yellow_light_05 from '../../studio/assets/illustrations/yellow_light_05.png';
import yellow_medium_05 from '../../studio/assets/illustrations/yellow_medium_05.png';
import yellow_dark_05 from '../../studio/assets/illustrations/yellow_dark_05.png';
import navy_light_05 from '../../studio/assets/illustrations/navy_light_05.png';
import navy_medium_05 from '../../studio/assets/illustrations/navy_medium_05.png';
import navy_dark_05 from '../../studio/assets/illustrations/navy_dark_05.png';

import green_light_06 from '../../studio/assets/illustrations/green_light_06.png';
import green_medium_06 from '../../studio/assets/illustrations/green_medium_06.png';
import green_dark_06 from '../../studio/assets/illustrations/green_dark_06.png';
import orange_light_06 from '../../studio/assets/illustrations/orange_light_06.png';
import orange_medium_06 from '../../studio/assets/illustrations/orange_medium_06.png';
import orange_dark_06 from '../../studio/assets/illustrations/orange_dark_06.png';
import blue_light_06 from '../../studio/assets/illustrations/blue_light_06.png';
import blue_medium_06 from '../../studio/assets/illustrations/blue_medium_06.png';
import blue_dark_06 from '../../studio/assets/illustrations/blue_dark_06.png';
import yellow_light_06 from '../../studio/assets/illustrations/yellow_light_06.png';
import yellow_medium_06 from '../../studio/assets/illustrations/yellow_medium_06.png';
import yellow_dark_06 from '../../studio/assets/illustrations/yellow_dark_06.png';
import navy_light_06 from '../../studio/assets/illustrations/navy_light_06.png';
import navy_medium_06 from '../../studio/assets/illustrations/navy_medium_06.png';
import navy_dark_06 from '../../studio/assets/illustrations/navy_dark_06.png';

import thumbnail1 from '../../studio/assets/illustrations/thumbnails_1.jpg';
import thumbnail2 from '../../studio/assets/illustrations/thumbnails_2.jpg';
import thumbnail3 from '../../studio/assets/illustrations/thumbnails_3.jpg';
import thumbnail4 from '../../studio/assets/illustrations/thumbnails_4.jpg';
import thumbnail5 from '../../studio/assets/illustrations/thumbnails_5.jpg';
import thumbnail6 from '../../studio/assets/illustrations/thumbnails_6.jpg';

const images = [
  // only 6 below are available to choose, leaving rest for backwards compatibility
  {
    id: 'thumbnail_1',
    src: thumbnail1,
    alt: 'giide thumbnail 1',
  },
  {
    id: 'thumbnail_2',
    src: thumbnail2,
    alt: 'giide thumbnail 2',
  },
  {
    id: 'thumbnail_3',
    src: thumbnail3,
    alt: 'giide thumbnail 3',
  },
  {
    id: 'thumbnail_4',
    src: thumbnail4,
    alt: 'giide thumbnail 4',
  },
  {
    id: 'thumbnail_5',
    src: thumbnail5,
    alt: 'giide thumbnail 5',
  },
  {
    id: 'thumbnail_6',
    src: thumbnail6,
    alt: 'giide thumbnail 6',
  },
  // end current thumbnail choices
  {
    id: 'green_light_01',
    src: green_light_01,
    alt: 'green_light_01',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_01',
    src: green_medium_01,
    alt: 'green_medium_01',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_01',
    src: green_dark_01,
    alt: 'green_dark_01',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_01',
    src: orange_light_01,
    alt: 'orange_light_01',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_01',
    src: orange_medium_01,
    alt: 'orange_medium_01',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_01',
    src: orange_dark_01,
    alt: 'orange_dark_01',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_01',
    src: blue_light_01,
    alt: 'blue_light_01',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_01',
    src: blue_medium_01,
    alt: 'blue_medium_01',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_01',
    src: blue_dark_01,
    alt: 'blue_dark_01',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_01',
    src: yellow_light_01,
    alt: 'yellow_light_01',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_01',
    src: yellow_medium_01,
    alt: 'yellow_medium_01',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_01',
    src: yellow_dark_01,
    alt: 'yellow_dark_01',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_01',
    src: navy_light_01,
    alt: 'navy_light_01',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_01',
    src: navy_medium_01,
    alt: 'navy_medium_01',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_01',
    src: navy_dark_01,
    alt: 'navy_dark_01',
    color: 'navy',
    shade: 'dark',
  },
  {
    id: 'green_light_02',
    src: green_light_02,
    alt: 'green_light_02',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_02',
    src: green_medium_02,
    alt: 'green_medium_02',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_02',
    src: green_dark_02,
    alt: 'green_dark_02',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_02',
    src: orange_light_02,
    alt: 'orange_light_02',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_02',
    src: orange_medium_02,
    alt: 'orange_medium_02',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_02',
    src: orange_dark_02,
    alt: 'orange_dark_02',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_02',
    src: blue_light_02,
    alt: 'blue_light_02',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_02',
    src: blue_medium_02,
    alt: 'blue_medium_02',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_02',
    src: blue_dark_02,
    alt: 'blue_dark_02',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_02',
    src: yellow_light_02,
    alt: 'yellow_light_02',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_02',
    src: yellow_medium_02,
    alt: 'yellow_medium_02',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_02',
    src: yellow_dark_02,
    alt: 'yellow_dark_02',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_02',
    src: navy_light_02,
    alt: 'navy_light_02',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_02',
    src: navy_medium_02,
    alt: 'navy_medium_02',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_02',
    src: navy_dark_02,
    alt: 'navy_dark_02',
    color: 'navy',
    shade: 'dark',
  },
  {
    id: 'green_light_03',
    src: green_light_03,
    alt: 'green_light_03',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_03',
    src: green_medium_03,
    alt: 'green_medium_03',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_03',
    src: green_dark_03,
    alt: 'green_dark_03',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_03',
    src: orange_light_03,
    alt: 'orange_light_03',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_03',
    src: orange_medium_03,
    alt: 'orange_medium_03',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_03',
    src: orange_dark_03,
    alt: 'orange_dark_03',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_03',
    src: blue_light_03,
    alt: 'blue_light_03',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_03',
    src: blue_medium_03,
    alt: 'blue_medium_03',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_03',
    src: blue_dark_03,
    alt: 'blue_dark_03',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_03',
    src: yellow_light_03,
    alt: 'yellow_light_03',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_03',
    src: yellow_medium_03,
    alt: 'yellow_medium_03',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_03',
    src: yellow_dark_03,
    alt: 'yellow_dark_03',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_03',
    src: navy_light_03,
    alt: 'navy_light_03',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_03',
    src: navy_medium_03,
    alt: 'navy_medium_03',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_03',
    src: navy_dark_03,
    alt: 'navy_dark_03',
    color: 'navy',
    shade: 'dark',
  },
  {
    id: 'green_light_04',
    src: green_light_04,
    alt: 'green_light_04',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_04',
    src: green_medium_04,
    alt: 'green_medium_04',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_04',
    src: green_dark_04,
    alt: 'green_dark_04',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_04',
    src: orange_light_04,
    alt: 'orange_light_04',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_04',
    src: orange_medium_04,
    alt: 'orange_medium_04',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_04',
    src: orange_dark_04,
    alt: 'orange_dark_04',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_04',
    src: blue_light_04,
    alt: 'blue_light_04',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_04',
    src: blue_medium_04,
    alt: 'blue_medium_04',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_04',
    src: blue_dark_04,
    alt: 'blue_dark_04',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_04',
    src: yellow_light_04,
    alt: 'yellow_light_04',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_04',
    src: yellow_medium_04,
    alt: 'yellow_medium_04',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_04',
    src: yellow_dark_04,
    alt: 'yellow_dark_04',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_04',
    src: navy_light_04,
    alt: 'navy_light_04',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_04',
    src: navy_medium_04,
    alt: 'navy_medium_04',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_04',
    src: navy_dark_04,
    alt: 'navy_dark_04',
    color: 'navy',
    shade: 'dark',
  },
  {
    id: 'green_light_05',
    src: green_light_05,
    alt: 'green_light_05',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_05',
    src: green_medium_05,
    alt: 'green_medium_05',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_05',
    src: green_dark_05,
    alt: 'green_dark_05',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_05',
    src: orange_light_05,
    alt: 'orange_light_05',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_05',
    src: orange_medium_05,
    alt: 'orange_medium_05',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_05',
    src: orange_dark_05,
    alt: 'orange_dark_05',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_05',
    src: blue_light_05,
    alt: 'blue_light_05',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_05',
    src: blue_medium_05,
    alt: 'blue_medium_05',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_05',
    src: blue_dark_05,
    alt: 'blue_dark_05',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_05',
    src: yellow_light_05,
    alt: 'yellow_light_05',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_05',
    src: yellow_medium_05,
    alt: 'yellow_medium_05',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_05',
    src: yellow_dark_05,
    alt: 'yellow_dark_05',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_05',
    src: navy_light_05,
    alt: 'navy_light_05',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_05',
    src: navy_medium_05,
    alt: 'navy_medium_05',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_05',
    src: navy_dark_05,
    alt: 'navy_dark_05',
    color: 'navy',
    shade: 'dark',
  },
  {
    id: 'green_light_06',
    src: green_light_06,
    alt: 'green_light_06',
    color: 'green',
    shade: 'light',
  },
  {
    id: 'green_medium_06',
    src: green_medium_06,
    alt: 'green_medium_06',
    color: 'green',
    shade: 'medium',
  },
  {
    id: 'green_dark_06',
    src: green_dark_06,
    alt: 'green_dark_06',
    color: 'green',
    shade: 'dark',
  },
  {
    id: 'orange_light_06',
    src: orange_light_06,
    alt: 'orange_light_06',
    color: 'orange',
    shade: 'light',
  },
  {
    id: 'orange_medium_06',
    src: orange_medium_06,
    alt: 'orange_medium_06',
    color: 'orange',
    shade: 'medium',
  },
  {
    id: 'orange_dark_06',
    src: orange_dark_06,
    alt: 'orange_dark_06',
    color: 'orange',
    shade: 'dark',
  },
  {
    id: 'blue_light_06',
    src: blue_light_06,
    alt: 'blue_light_06',
    color: 'blue',
    shade: 'light',
  },
  {
    id: 'blue_medium_06',
    src: blue_medium_06,
    alt: 'blue_medium_06',
    color: 'blue',
    shade: 'medium',
  },
  {
    id: 'blue_dark_06',
    src: blue_dark_06,
    alt: 'blue_dark_06',
    color: 'blue',
    shade: 'dark',
  },
  {
    id: 'yellow_light_06',
    src: yellow_light_06,
    alt: 'yellow_light_06',
    color: 'yellow',
    shade: 'light',
  },
  {
    id: 'yellow_medium_06',
    src: yellow_medium_06,
    alt: 'yellow_medium_06',
    color: 'yellow',
    shade: 'medium',
  },
  {
    id: 'yellow_dark_06',
    src: yellow_dark_06,
    alt: 'yellow_dark_06',
    color: 'yellow',
    shade: 'dark',
  },
  {
    id: 'navy_light_06',
    src: navy_light_06,
    alt: 'navy_light_06',
    color: 'navy',
    shade: 'light',
  },
  {
    id: 'navy_medium_06',
    src: navy_medium_06,
    alt: 'navy_medium_06',
    color: 'navy',
    shade: 'medium',
  },
  {
    id: 'navy_dark_06',
    src: navy_dark_06,
    alt: 'navy_dark_06',
    color: 'navy',
    shade: 'dark',
  },
];

export default images;
